import './Icon_Filter.css';

function Icon_Filter() {
  return (
    <div className='icon-container-filter'>
      <svg className="filter-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46 22,3"></polygon>
      </svg>
    </div>
  );
}

export default Icon_Filter;